import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=d03d188e&scoped=true&"
import script from "./Page404.vue?vue&type=script&lang=js&"
export * from "./Page404.vue?vue&type=script&lang=js&"
import style0 from "./Page404.vue?vue&type=style&index=0&id=d03d188e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03d188e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d03d188e')) {
      api.createRecord('d03d188e', component.options)
    } else {
      api.reload('d03d188e', component.options)
    }
    module.hot.accept("./Page404.vue?vue&type=template&id=d03d188e&scoped=true&", function () {
      api.rerender('d03d188e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page404/Page404.vue"
export default component.exports